import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import webSocket from '@/sockets/socket';
class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  getDevices = 'number-device';
  update = 'update';
  nearest = 'nearest';
  detail = 'detail';
  exchangeRate = 'exchange-rate';

  async getDetailRequest(id) {
    let request = {
      url: [this.getAPIUrl(), 'edit', id].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  /**
   * Lấy danh sách chi tiết request theo nhiều request_id (dùng cho multi upgrade/extend)
   * Created by: AI Assistant - 12/03/2026
   */
  async getDetailRequestsBatch(ids) {
    let request = {
      url: [this.getAPIUrl(), 'edit-batch'].join('/'),
      data: ids || [],
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getDetailRequestCompanyCode(companyCode) {
    let request = {
      url: [this.getAPIUrl(), this.detail, companyCode].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  async insertRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: model,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }
  
  async updateRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.update].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Lưu nhiều request trong một lần gọi
   * Created by: AI Assistant - 12/03/2026
   */
  async saveBatchRequests(payload) {
    let request = {
      url: [this.getAPIUrl(), 'save-batch'].join('/'),
      data: payload || [],
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  async getDevicesOfDomain(domain, key) {
    let request = {
      url: [this.getAPIUrl(), this.getDevices, domain].join('/'),
      data: JSON.stringify({ packageUpgradeKey: key }),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async deletelRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.deleteAsync(request);

    return res;
  }

  async nearestRequest() {
    let request = {
      url: [this.getAPIUrl(), this.nearest].join('/'),
    };
    var res = httpClient.getAsync(request, false);
    return res;
  }

  /**
   * Tạo multi-branch request cho nhiều chi nhánh
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async createMultiBranchRequest(payload) {
    let request = {
      url: [this.getAPIUrl(), 'multi-branch'].join('/'),
      data: payload,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Lấy chi tiết parent request với children
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getParentRequestDetail(parentId) {
    let request = {
      url: [this.getAPIUrl(), 'parent', parentId].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  /**
   * Lấy danh sách children của parent request
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getRequestChildren(parentId) {
    let request = {
      url: [this.getAPIUrl(), 'parent', parentId, 'children'].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }
  
  /**
   * Description: Tạo hoặc cập nhật request theo companyCode thủ công
   * Created by: ndthi
   * Created date: 2024-07-23
   */
  async manualCreateUpdateRequest(companyCode) {
    let request = {
      url: [this.getAPIUrl(), 'manual-create-update-request-auth', companyCode].join('/')
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Cập nhật partner cho danh sách công ty
   * Created by: ndthi
   * Created date: 2024-07-24
   */
  async updatePartnerBatch(payload) {
    let request = {
      url: [this.getAPIUrl(), 'update-partner-batch'].join('/'),
      data: payload
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Force Update Global
   * Created by: ndthi
   * Created date: 2024-07-24
   */
  async forceUpdate(apiKey) {
    let request = {
      url: [this.getAPIUrl(), 'force-update'].join('/'),
      headers: {
        'x-license-hub-api-key': apiKey
      }
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Gửi email inactive tự động
   * Created by: ndthi
   * Created date: 2025-12-15
   */
  async sendMailInactiveAutomatic() {
    let request = {
      url: [this.getAPIUrl(), 'send-mail-inactive-automatic'].join('/')
    };
    var res = await httpClient.postAsync(request);
    return res;
  }
  async getVCBExchangeRate() {
    let request = {
      url: [this.getAPIUrl(), this.exchangeRate].join('/'),
    };
    var res = await httpClient.getAsync(request, false);
    return res;
  }
}

export default new RequestAPI();